import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../../shared";
import { DataService_MultiStationSettings } from "../shared/data.service";
import { DistrictSettingsUpdateRequest } from "../shared/DistrictSettingsUpdateRequest";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "caass-multistation-district-settings",
	templateUrl: "./multistation-district-settings.component.html",
	styleUrls: ["./multistation-district-settings.component.css"],
})
export class MultistationDistrictSettingsComponent implements OnInit {
	constructor(private userService: UserService, private dataService: DataService_MultiStationSettings, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		if (this.user.userID == 0) {
			this.IsSU = true;
		}

		this.loadData();
	}

	///////////////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////////////

	//
	//  Preferences from DB
	//
	A411_VisitorModeEnabled: boolean = false;
	A411_StudentModeEnabled: boolean = false;
	A411_StaffModeEnabled: boolean = false;
	A411_OffenderLookupEnabled: boolean = false;
	VisitorModeEnabled: boolean = false;
	VisitorModeCanOverride: boolean = false;
	StudentModeEnabled: boolean = false;
	StudentModeCanOverride: boolean = false;
	StaffModeEnabled: boolean = false;
	StaffModeCanOverride: boolean = false;
	OffenderLookupEnabled: boolean = false;
	OffenderLookupCanOverride: boolean = false;
	PanicButtonEnabled: boolean = false;
	PanicButtonCanOverride: boolean = false;
	ConfirmPanicButtonEnabled: boolean = false;
	ConfirmPanicButtonCanOverride: boolean = false;
	PanicButtonText: string = "";
	PanicButtonTextCanOverride: boolean = false;
	ConfirmPanicButtonText: string = "";
	ConfirmPanicButtonTextCanOverride: boolean = false;
	Default_PanicButtonTopicID: number = 0;
	PanicButtonTopicCanOverride: boolean = false;
	PhotoRequired: boolean = false;
	PhotoRequiredCanOverride: boolean = false;
	SkipPhotoIfNotRequired: boolean = false;
	SkipPhotoIfNotRequiredCanOverride: boolean = false;
	UseDriversLicensePhoto: boolean = false;
	UseDriversLicensePhotoCanOverride: boolean = false;
	AllowExistingPhoto: boolean = false;
	AllowExistingPhotoCanOverride: boolean = false;
	ForceRetakePhotoAfterXDays: number = 0;
	ForceRetakePhotoCanOverride: boolean = false;
	Default_PrinterAlignTop: number = 0;
	Default_PrinterAlignLeft: number = 0;
	PrintStudentLatePasses: boolean = false;
	PrintStudentLatePassesCanOverride: boolean = false;
	PrintStudentEntryPasses: boolean = false;
	PrintStudentEntryPassesCanOverride: boolean = false;
	SkipConfirmInfo: boolean = false;
	SkipConfirmInfoCanOverride: boolean = false;
	SkipVisitorType: boolean = false;
	SkipVisitorTypeCanOverride: boolean = false;
	DefaultVisitorTypeID: number = 0;
	DefaultVisitorTypeCanOverride: boolean = false;
	SkipVisitee: boolean = false;
	SkipVisiteeCanOverride: boolean = false;
	SelectedVisitee: any;
	DefaultVisiteeSchoolID: number = 0;
	DefaultVisiteeID: number = 0;
	DefaultVisiteeCanOverride: boolean = false;
	DefaultVisiteeFacilityLocationID: number = 0;
	SkipVisitReason: boolean = false;
	SkipVisitReasonCanOverride: boolean = false;
	DefaultVisitReasonID: number = 0;
	DefaultVisitReasonCanOverride: boolean = false;
	SkipAdditionalNotes: boolean = false;
	SkipAdditionalNotesCanOverride: boolean = false;
	SkipSignature: boolean = false;
	SkipSignatureCanOverride: boolean = false;
	UseDriversLicenseSignature: boolean = false;
	UseDriversLicenseSignatureCanOverride: boolean = false;
	SelfCheckInVerifyText: string = "";
	SelfCheckInVerifyTextCanOverride: boolean = false;
	Default_KeyboardMode: number = 0;
	Default_FacilityID: number = 0;
	Default_FacilityLocationID: number = 0;
	SyncDropdownMinutes: number = 0;
	SyncDropdownMinutesCanOverride: boolean = false;
	StationMode: number = 0;
	StationModeCanOverride: boolean = false;
	Template_OffenderHit: string = "";
	Template_VerificationReqd: string = "";
	Template_Default: string = "";
	Template_OffenderHitCanOverride: boolean = false;
	Template_VerificationReqdCanOverride: boolean = false;
	Template_DefaultCanOverride: boolean = false;
	CurrentVersion: string = "";
	c_Date: Date = new Date();
	c_DateDesc: string = "";
	OffenderLookupHostID: number = 0;

	lstVisitorType: any = [];
	lstVisitReason: any = [];
	lstVisitee: any = [];
	lstIDCardTemplate: any = [];
	lstPanicButtonTopic: any = [];
	lstFacility: any = [];
	lstFacilityLocation: any = [];
	lstKeyboardMode: any = [];
	lstStationMode: any = [];
	lstOffenderHost: any = [];

	//
	//  Misc
	//
	user: any;
	IsSU: boolean = false;

	//
	//  Loading
	//
	errorMessage: string = "";

	PreferenceLoading: boolean = false;
	FacilityLocationLoading: boolean = false;
	IDCardLoading: boolean = false;
	VisiteeLoading: boolean = false;
	PanicTopicLoading: boolean = false;
	Processing: boolean = false;

	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////////////////

	loadData() {
		this.errorMessage = "";
		this.PreferenceLoading = true;

		var result = this.dataService.DistrictSettingsSelect();
		result.subscribe(
			(response: any) => {
				this.A411_VisitorModeEnabled = response.A411_VisitorModeEnabled;
				this.A411_StudentModeEnabled = response.A411_StudentModeEnabled;
				this.A411_StaffModeEnabled = response.A411_StaffModeEnabled;
				this.A411_OffenderLookupEnabled = response.A411_OffenderLookupEnabled;
				this.VisitorModeEnabled = response.VisitorModeEnabled;
				this.VisitorModeCanOverride = response.VisitorModeCanOverride;
				this.StudentModeEnabled = response.StudentModeEnabled;
				this.StudentModeCanOverride = response.StudentModeCanOverride;
				this.StaffModeEnabled = response.StaffModeEnabled;
				this.StaffModeCanOverride = response.StaffModeCanOverride;
				this.OffenderLookupEnabled = response.OffenderLookupEnabled;
				this.OffenderLookupCanOverride = response.OffenderLookupCanOverride;
				this.PanicButtonEnabled = response.PanicButtonEnabled;
				this.PanicButtonCanOverride = response.PanicButtonCanOverride;
				this.ConfirmPanicButtonEnabled = response.ConfirmPanicButtonEnabled;
				this.ConfirmPanicButtonCanOverride = response.ConfirmPanicButtonCanOverride;
				this.PanicButtonText = response.PanicButtonText;
				this.PanicButtonTextCanOverride = response.PanicButtonTextCanOverride;
				this.ConfirmPanicButtonText = response.ConfirmPanicButtonText;
				this.ConfirmPanicButtonTextCanOverride = response.ConfirmPanicButtonTextCanOverride;
				this.Default_PanicButtonTopicID = response.Default_PanicButtonTopicID;
				this.PanicButtonTopicCanOverride = response.PanicButtonTopicCanOverride;
				this.PhotoRequired = response.PhotoRequired;
				this.PhotoRequiredCanOverride = response.PhotoRequiredCanOverride;
				this.SkipPhotoIfNotRequired = response.SkipPhotoIfNotRequired;
				this.SkipPhotoIfNotRequiredCanOverride = response.SkipPhotoIfNotRequiredCanOverride;
				this.UseDriversLicensePhoto = response.UseDriversLicensePhoto;
				this.UseDriversLicensePhotoCanOverride = response.UseDriversLicensePhotoCanOverride;
				this.AllowExistingPhoto = response.AllowExistingPhoto;
				this.AllowExistingPhotoCanOverride = response.AllowExistingPhotoCanOverride;
				this.ForceRetakePhotoAfterXDays = response.ForceRetakePhotoAfterXDays;
				this.ForceRetakePhotoCanOverride = response.ForceRetakePhotoCanOverride;
				this.Default_PrinterAlignTop = response.Default_PrinterAlignTop;
				this.Default_PrinterAlignLeft = response.Default_PrinterAlignLeft;
				this.PrintStudentLatePasses = response.PrintStudentLatePasses;
				this.PrintStudentLatePassesCanOverride = response.PrintStudentLatePassesCanOverride;
				this.PrintStudentEntryPasses = response.PrintStudentEntryPasses;
				this.PrintStudentEntryPassesCanOverride = response.PrintStudentEntryPassesCanOverride;
				this.SkipConfirmInfo = response.SkipConfirmInfo;
				this.SkipConfirmInfoCanOverride = response.SkipConfirmInfoCanOverride;
				this.SkipVisitorType = response.SkipVisitorType;
				this.SkipVisitorTypeCanOverride = response.SkipVisitorTypeCanOverride;
				this.DefaultVisitorTypeID = response.DefaultVisitorTypeID;
				this.DefaultVisitorTypeCanOverride = response.DefaultVisitorTypeCanOverride;
				this.SkipVisitee = response.SkipVisitee;
				this.SkipVisiteeCanOverride = response.SkipVisiteeCanOverride;
				this.DefaultVisiteeSchoolID = response.DefaultVisiteeSchoolID;
				this.DefaultVisiteeID = response.DefaultVisiteeID;
				this.DefaultVisiteeCanOverride = response.DefaultVisiteeCanOverride;
				this.DefaultVisiteeFacilityLocationID = response.DefaultVisiteeFacilityLocationID;
				this.SkipVisitReason = response.SkipVisitReason;
				this.SkipVisitReasonCanOverride = response.SkipVisitReasonCanOverride;
				this.DefaultVisitReasonID = response.DefaultVisitReasonID;
				this.DefaultVisitReasonCanOverride = response.DefaultVisitReasonCanOverride;
				this.SkipAdditionalNotes = response.SkipAdditionalNotes;
				this.SkipAdditionalNotesCanOverride = response.SkipAdditionalNotesCanOverride;
				this.SkipSignature = response.SkipSignature;
				this.SkipSignatureCanOverride = response.SkipSignatureCanOverride;
				this.UseDriversLicenseSignature = response.UseDriversLicenseSignature;
				this.UseDriversLicenseSignatureCanOverride = response.UseDriversLicenseSignatureCanOverride;
				this.SelfCheckInVerifyText = response.SelfCheckInVerifyText;
				this.SelfCheckInVerifyTextCanOverride = response.SelfCheckInVerifyTextCanOverride;
				this.Default_KeyboardMode = response.Default_KeyboardMode;
				this.Default_FacilityID = response.Default_FacilityID;
				this.Default_FacilityLocationID = response.Default_FacilityLocationID;
				this.SyncDropdownMinutes = response.SyncDropdownMinutes;
				this.SyncDropdownMinutesCanOverride = response.SyncDropdownMinutesCanOverride;
				this.StationMode = response.StationMode;
				this.StationModeCanOverride = response.StationModeCanOverride;
				this.Template_OffenderHit = response.Template_OffenderHit;
				this.Template_VerificationReqd = response.Template_VerificationReqd;
				this.Template_Default = response.Template_Default;
				this.Template_OffenderHitCanOverride = response.Template_OffenderHitCanOverride;
				this.Template_VerificationReqdCanOverride = response.Template_VerificationReqdCanOverride;
				this.Template_DefaultCanOverride = response.Template_DefaultCanOverride;
				this.CurrentVersion = response.CurrentVersion;
				this.c_Date = new Date(response.c_Date);
				this.c_DateDesc = response.c_DateDesc;
				this.OffenderLookupHostID = response.OffenderLookupHostID;

				this.lstVisitorType = response.lstVisitorType;
				this.lstVisitReason = response.lstVisitReason;
				this.lstVisitee = response.lstVisitee;
				this.lstIDCardTemplate = response.lstIDCardTemplate;
				this.lstPanicButtonTopic = response.lstPanicButtonTopic;
				this.lstFacility = response.lstFacility;
				// this.lstFacilityLocation = response.lstFacilityLocation;
				this.lstKeyboardMode = response.lstKeyboardMode;
				this.lstStationMode = response.lstStationMode;
				this.lstOffenderHost = response.lstOffenderHost;

				//
				//	Update Dropdowns
				//
				this.UpdateSelected();

				this.PreferenceLoading = false;
			},
			(error) => {
				this.PreferenceLoading = false;
			}
		);
	}

	UpdateSelected() {
		var temp = -1;

		//
		//	DefaultVisitorTypeID
		//
		temp = -1;
		if (this.lstVisitorType.length > 0) {
			temp = this.lstVisitorType[0].ID;
			for (var z = 0; z < this.lstVisitorType.length; z++) {
				var next = this.lstVisitorType[z];

				if (this.DefaultVisitorTypeID == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.DefaultVisitorTypeID = Number(temp);

		//
		//	DefaultVisitReasonID
		//
		temp = -1;
		if (this.lstVisitReason.length > 0) {
			temp = this.lstVisitReason[0].ID;
			for (var z = 0; z < this.lstVisitReason.length; z++) {
				var next = this.lstVisitReason[z];

				if (this.DefaultVisitReasonID == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.DefaultVisitReasonID = Number(temp);

		//
		//	Default_KeyboardMode
		//
		temp = -1;
		if (this.lstKeyboardMode.length > 0) {
			temp = this.lstKeyboardMode[0].ID;
			for (var z = 0; z < this.lstKeyboardMode.length; z++) {
				var next = this.lstKeyboardMode[z];

				if (this.Default_KeyboardMode == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.Default_KeyboardMode = Number(temp);

		//
		//	StationMode
		//
		temp = -1;
		if (this.lstStationMode.length > 0) {
			temp = this.lstStationMode[0].ID;
			for (var z = 0; z < this.lstStationMode.length; z++) {
				var next = this.lstStationMode[z];

				if (this.StationMode == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.StationMode = Number(temp);

		//
		//	Default_FacilityID
		//
		temp = -1;
		if (this.lstFacility.length > 0) {
			temp = this.lstFacility[0].ID;
			for (var z = 0; z < this.lstFacility.length; z++) {
				var next = this.lstFacility[z];

				if (this.Default_FacilityID == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.Default_FacilityID = Number(temp);

		this.loadFacilityLocation(Number(this.Default_FacilityLocationID));
		this.loadIDCardTemplates(String(this.Template_Default), String(this.Template_VerificationReqd), String(this.Template_OffenderHit));
		this.loadVisitees(Number(this.DefaultVisiteeID), Number(this.DefaultVisiteeFacilityLocationID));
		this.loadPanicAlertTopics(Number(this.Default_PanicButtonTopicID));
	}

	loadFacilityLocation(facilityLocationID: number) {
		this.errorMessage = "";
		this.FacilityLocationLoading = true;

		var result = this.dataService.SettingsFacilityLocationSelectList(this.Default_FacilityID);
		result.subscribe(
			(response: any) => {
				this.lstFacilityLocation = response;

				var temp = -1;
				if (this.lstFacilityLocation.length > 0) {
					temp = Number(this.lstFacilityLocation[0].ID);
					for (var z = 0; z < this.lstFacilityLocation.length; z++) {
						var next = this.lstFacilityLocation[z];

						if (next.ID == facilityLocationID) {
							temp = Number(next.ID);
						}
					}
				}
				this.Default_FacilityLocationID = temp;

				this.FacilityLocationLoading = false;
			},
			(error) => {
				this.FacilityLocationLoading = false;
			}
		);
	}

	loadIDCardTemplates(guid_default: string, guid_verreq: string, guid_offender: string) {
		this.errorMessage = "";
		this.IDCardLoading = true;

		var result = this.dataService.IDCardTemplateSelectList(this.Default_FacilityID);
		result.subscribe(
			(response: any) => {
				this.lstIDCardTemplate = response;

				//
				//	Template_Default
				//	Template_VerificationReqd
				//	Template_OffenderHit
				//
				if (this.lstIDCardTemplate.length > 0) {
					var temp_default = String(this.lstIDCardTemplate[0].IDCardTemplateID);
					var temp_verreq = String(this.lstIDCardTemplate[0].IDCardTemplateID);
					var temp_offender = String(this.lstIDCardTemplate[0].IDCardTemplateID);

					for (var z = 0; z < this.lstIDCardTemplate.length; z++) {
						var next = this.lstIDCardTemplate[z];

						if (guid_default == next.IDCardTemplateID) {
							temp_default = String(next.IDCardTemplateID);
						}
						if (guid_verreq == next.IDCardTemplateID) {
							temp_verreq = String(next.IDCardTemplateID);
						}
						if (guid_offender == next.IDCardTemplateID) {
							temp_offender = String(next.IDCardTemplateID);
						}
					}
					this.Template_Default = temp_default;
					this.Template_VerificationReqd = temp_verreq;
					this.Template_OffenderHit = temp_offender;
				}

				this.IDCardLoading = false;
			},
			(error) => {
				this.IDCardLoading = false;
			}
		);
	}

	loadVisitees(visiteeID: number, facilityLocationID: number) {
		this.errorMessage = "";
		this.VisiteeLoading = true;

		var result = this.dataService.SettingsVisiteeSelectList(this.Default_FacilityID);
		result.subscribe(
			(response: any) => {
				this.lstVisitee = response;

				if (this.lstVisitee.length > 0) {
					var tempPerson = this.lstVisitee[0];
					var tempLocation = this.lstVisitee[0];
					var vPersonFound = false;
					var vLocationFound = false;

					for (var z = 0; z < this.lstVisitee.length; z++) {
						var next = this.lstVisitee[z];

						if (next.VisiteeID == visiteeID) {
							vPersonFound = true;
							tempPerson = next;
							break; // (Only Break for Visitee Person)
						}
						if (next.FacilityLocationID == facilityLocationID) {
							vLocationFound = true;
							tempLocation = next;
						}
					}

					if (vPersonFound == true) {
						this.SelectedVisitee = tempPerson;
					} else {
						this.SelectedVisitee = tempLocation;
					}
				} else {
					this.SelectedVisitee = null;
				}

				this.VisiteeLoading = false;
			},
			(error) => {
				this.VisiteeLoading = false;
			}
		);
	}

	loadPanicAlertTopics(topicID: number) {
		this.errorMessage = "";
		this.PanicTopicLoading = true;

		var result = this.dataService.SettingsPanicButtonTopicSelectList(this.Default_FacilityID);
		result.subscribe(
			(response: any) => {
				this.lstPanicButtonTopic = response;

				var temp = -1;
				if (this.lstPanicButtonTopic.length > 0) {
					temp = Number(this.lstPanicButtonTopic[0].ID);
					for (var z = 0; z < this.lstPanicButtonTopic.length; z++) {
						var next = this.lstPanicButtonTopic[z];

						if (next.ID == topicID) {
							temp = Number(next.ID);
						}
					}
				}
				this.Default_PanicButtonTopicID = temp;

				this.PanicTopicLoading = false;
			},
			(error) => {
				this.PanicTopicLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadData();
	}

	onUpdate() {
		this.errorMessage = "";

		//
		//	Error Handling
		//

		//
		//	Make WS Request
		//
		var parms: DistrictSettingsUpdateRequest = {
			A411_VisitorModeEnabled: this.A411_VisitorModeEnabled,
			A411_StudentModeEnabled: this.A411_StudentModeEnabled,
			A411_StaffModeEnabled: this.A411_StaffModeEnabled,
			A411_OffenderLookupEnabled: this.A411_OffenderLookupEnabled,
			VisitorModeEnabled: this.VisitorModeEnabled,
			VisitorModeCanOverride: this.VisitorModeCanOverride,
			StudentModeEnabled: this.StudentModeEnabled,
			StudentModeCanOverride: this.StudentModeCanOverride,
			StaffModeEnabled: this.StaffModeEnabled,
			StaffModeCanOverride: this.StaffModeCanOverride,
			OffenderLookupEnabled: this.OffenderLookupEnabled,
			OffenderLookupCanOverride: this.OffenderLookupCanOverride,
			PanicButtonEnabled: this.PanicButtonEnabled,
			PanicButtonCanOverride: this.PanicButtonCanOverride,
			ConfirmPanicButtonEnabled: this.ConfirmPanicButtonEnabled,
			ConfirmPanicButtonCanOverride: this.ConfirmPanicButtonCanOverride,
			PanicButtonText: this.PanicButtonText,
			PanicButtonTextCanOverride: this.PanicButtonTextCanOverride,
			ConfirmPanicButtonText: this.ConfirmPanicButtonText,
			ConfirmPanicButtonTextCanOverride: this.ConfirmPanicButtonTextCanOverride,
			Default_PanicButtonTopicID: this.Default_PanicButtonTopicID,
			PanicButtonTopicCanOverride: this.PanicButtonTopicCanOverride,
			PhotoRequired: this.PhotoRequired,
			PhotoRequiredCanOverride: this.PhotoRequiredCanOverride,
			SkipPhotoIfNotRequired: this.SkipPhotoIfNotRequired,
			SkipPhotoIfNotRequiredCanOverride: this.SkipPhotoIfNotRequiredCanOverride,
			UseDriversLicensePhoto: this.UseDriversLicensePhoto,
			UseDriversLicensePhotoCanOverride: this.UseDriversLicensePhotoCanOverride,
			AllowExistingPhoto: this.AllowExistingPhoto,
			AllowExistingPhotoCanOverride: this.AllowExistingPhotoCanOverride,
			ForceRetakePhotoAfterXDays: this.ForceRetakePhotoAfterXDays,
			ForceRetakePhotoCanOverride: this.ForceRetakePhotoCanOverride,
			Default_PrinterAlignTop: this.Default_PrinterAlignTop,
			Default_PrinterAlignLeft: this.Default_PrinterAlignLeft,
			PrintStudentLatePasses: this.PrintStudentLatePasses,
			PrintStudentLatePassesCanOverride: this.PrintStudentLatePassesCanOverride,
			PrintStudentEntryPasses: this.PrintStudentEntryPasses,
			PrintStudentEntryPassesCanOverride: this.PrintStudentEntryPassesCanOverride,
			SkipConfirmInfo: this.SkipConfirmInfo,
			SkipConfirmInfoCanOverride: this.SkipConfirmInfoCanOverride,
			SkipVisitorType: this.SkipVisitorType,
			SkipVisitorTypeCanOverride: this.SkipVisitorTypeCanOverride,
			DefaultVisitorTypeID: this.DefaultVisitorTypeID,
			DefaultVisitorTypeCanOverride: this.DefaultVisitorTypeCanOverride,
			SkipVisitee: this.SkipVisitee,
			SkipVisiteeCanOverride: this.SkipVisiteeCanOverride,
			DefaultVisiteeSchoolID: this.SelectedVisitee.SchoolID,
			DefaultVisiteeID: this.SelectedVisitee.VisiteeID,
			DefaultVisiteeCanOverride: this.DefaultVisiteeCanOverride,
			DefaultVisiteeFacilityLocationID: this.SelectedVisitee.FacilityLocationID,
			SkipVisitReason: this.SkipVisitReason,
			SkipVisitReasonCanOverride: this.SkipVisitReasonCanOverride,
			DefaultVisitReasonID: this.DefaultVisitReasonID,
			DefaultVisitReasonCanOverride: this.DefaultVisitReasonCanOverride,
			SkipAdditionalNotes: this.SkipAdditionalNotes,
			SkipAdditionalNotesCanOverride: this.SkipAdditionalNotesCanOverride,
			SkipSignature: this.SkipSignature,
			SkipSignatureCanOverride: this.SkipSignatureCanOverride,
			UseDriversLicenseSignature: this.UseDriversLicenseSignature,
			UseDriversLicenseSignatureCanOverride: this.UseDriversLicenseSignatureCanOverride,
			SelfCheckInVerifyText: this.SelfCheckInVerifyText,
			SelfCheckInVerifyTextCanOverride: this.SelfCheckInVerifyTextCanOverride,
			Default_KeyboardMode: this.Default_KeyboardMode,
			Default_FacilityID: this.Default_FacilityID,
			Default_FacilityLocationID: this.Default_FacilityLocationID,
			SyncDropdownMinutes: this.SyncDropdownMinutes,
			SyncDropdownMinutesCanOverride: this.SyncDropdownMinutesCanOverride,
			StationMode: this.StationMode,
			StationModeCanOverride: this.StationModeCanOverride,
			Template_OffenderHit: this.Template_OffenderHit,
			Template_VerificationReqd: this.Template_VerificationReqd,
			Template_Default: this.Template_Default,
			Template_OffenderHitCanOverride: this.Template_OffenderHitCanOverride,
			Template_VerificationReqdCanOverride: this.Template_VerificationReqdCanOverride,
			Template_DefaultCanOverride: this.Template_DefaultCanOverride,
			OffenderLookupHostID: this.OffenderLookupHostID,
		};

		this.Processing = true;
		var result = this.dataService.DistrictSettingsUpdate(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "district",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "District Settings were updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadData();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "district",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update district settings: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////////////////

	onDefault_FacilityIDChange(val) {
		this.Default_FacilityID = val;

		this.loadFacilityLocation(-1);
		this.loadIDCardTemplates("", "", "");
		this.loadVisitees(-1, -1);
		this.loadPanicAlertTopics(-1);
	}

	//
	//  Can Override
	//
	onToggleVisitorModeCanOverride() {
		this.VisitorModeCanOverride = !this.VisitorModeCanOverride;
	}

	onToggleStudentModeCanOverride() {
		this.StudentModeCanOverride = !this.StudentModeCanOverride;
	}
	onToggleStaffModeCanOverride() {
		this.StaffModeCanOverride = !this.StaffModeCanOverride;
	}
	onToggleOffenderLookupCanOverride() {
		this.OffenderLookupCanOverride = !this.OffenderLookupCanOverride;
	}
	onTogglePanicButtonCanOverride() {
		this.PanicButtonCanOverride = !this.PanicButtonCanOverride;
	}
	onToggleConfirmPanicButtonCanOverride() {
		this.ConfirmPanicButtonCanOverride = !this.ConfirmPanicButtonCanOverride;
	}
	onTogglePanicButtonTextCanOverride() {
		this.PanicButtonTextCanOverride = !this.PanicButtonTextCanOverride;
	}
	onToggleConfirmPanicButtonTextCanOverride() {
		this.ConfirmPanicButtonTextCanOverride = !this.ConfirmPanicButtonTextCanOverride;
	}
	onTogglePanicButtonTopicCanOverride() {
		this.PanicButtonTopicCanOverride = !this.PanicButtonTopicCanOverride;
	}
	onTogglePhotoRequiredCanOverride() {
		this.PhotoRequiredCanOverride = !this.PhotoRequiredCanOverride;
	}
	onToggleSkipPhotoIfNotRequiredCanOverride() {
		this.SkipPhotoIfNotRequiredCanOverride = !this.SkipPhotoIfNotRequiredCanOverride;
	}
	onToggleUseDriversLicensePhotoCanOverride() {
		this.UseDriversLicensePhotoCanOverride = !this.UseDriversLicensePhotoCanOverride;
	}
	onToggleAllowExistingPhotoCanOverride() {
		this.AllowExistingPhotoCanOverride = !this.AllowExistingPhotoCanOverride;
	}
	onToggleForceRetakePhotoCanOverride() {
		this.ForceRetakePhotoCanOverride = !this.ForceRetakePhotoCanOverride;
	}
	onTogglePrintStudentLatePassesCanOverride() {
		this.PrintStudentLatePassesCanOverride = !this.PrintStudentLatePassesCanOverride;
	}
	onTogglePrintStudentEntryPassesCanOverride() {
		this.PrintStudentEntryPassesCanOverride = !this.PrintStudentEntryPassesCanOverride;
	}
	onToggleSkipConfirmInfoCanOverride() {
		this.SkipConfirmInfoCanOverride = !this.SkipConfirmInfoCanOverride;
	}
	onToggleSkipVisitorTypeCanOverride() {
		this.SkipVisitorTypeCanOverride = !this.SkipVisitorTypeCanOverride;
	}
	onToggleDefaultVisitorTypeCanOverride() {
		this.DefaultVisitorTypeCanOverride = !this.DefaultVisitorTypeCanOverride;
	}
	onToggleSkipVisiteeCanOverride() {
		this.SkipVisiteeCanOverride = !this.SkipVisiteeCanOverride;
	}
	onToggleDefaultVisiteeCanOverride() {
		this.DefaultVisiteeCanOverride = !this.DefaultVisiteeCanOverride;
	}
	onToggleSkipVisitReasonCanOverride() {
		this.SkipVisitReasonCanOverride = !this.SkipVisitReasonCanOverride;
	}
	onToggleDefaultVisitReasonCanOverride() {
		this.DefaultVisitReasonCanOverride = !this.DefaultVisitReasonCanOverride;
	}
	onToggleSkipAdditionalNotesCanOverride() {
		this.SkipAdditionalNotesCanOverride = !this.SkipAdditionalNotesCanOverride;
	}
	onToggleSkipSignatureCanOverride() {
		this.SkipSignatureCanOverride = !this.SkipSignatureCanOverride;
	}
	onToggleUseDriversLicenseSignatureCanOverride() {
		this.UseDriversLicenseSignatureCanOverride = !this.UseDriversLicenseSignatureCanOverride;
	}
	onToggleSelfCheckInVerifyTextCanOverride() {
		this.SelfCheckInVerifyTextCanOverride = !this.SelfCheckInVerifyTextCanOverride;
	}
	onToggleSyncDropdownMinutesCanOverride() {
		this.SyncDropdownMinutesCanOverride = !this.SyncDropdownMinutesCanOverride;
	}
	onToggleStationModeCanOverride() {
		this.StationModeCanOverride = !this.StationModeCanOverride;
	}
	onToggleTemplate_OffenderHitCanOverride() {
		this.Template_OffenderHitCanOverride = !this.Template_OffenderHitCanOverride;
	}
	onToggleTemplate_VerificationReqdCanOverride() {
		this.Template_VerificationReqdCanOverride = !this.Template_VerificationReqdCanOverride;
	}
	onToggleTemplate_DefaultCanOverride() {
		this.Template_DefaultCanOverride = !this.Template_DefaultCanOverride;
	}

	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return (
			this.PreferenceLoading == true ||
			this.FacilityLocationLoading == true ||
			this.IDCardLoading == true ||
			this.VisiteeLoading == true ||
			this.PanicTopicLoading == true ||
			this.Processing == true
		);
	}

	///////////////////////////////////////////////////////////////////////////////////////
}
